import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { loadWebhooks } from '../../../../../../../../../rest/effects/webhooks/loadWebhooks';
import { TBoardId } from '../../../../../../../../../types/types';

export const onDidMount = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        return dispatch(loadWebhooks(boardId));
    };
    return action;
};
